export default "__VITE_ASSET__Cs_u$WLJ__"